module.exports = __webpack_public_path__ + "static/img/intro.11782d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/intro.png
// module id = 5SWT
// module chunks = 1